import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import HCPHeader from "../Navigation/HCPHeader";
import HCPSidebar from "../Navigation/HCPSidebar";

export default function HCPLayout() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <>
      <HCPSidebar open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} />
      <Box sx={{ display: "flex", height: "100vh", fontFamily: '"Montserrat", sans-serif' }}>
        <Box sx={{ flex: 1, background: "#f5f7fb", display: "flex", flexDirection: "column", overflow: "hidden" }}>
          <HCPHeader onMenuClick={() => setIsDrawerOpen(true)} />

          <Box component="main" sx={{ px: 3, pb: 3, pt: 0, flex: 1, overflowY: "auto" }}>
            <Outlet />
          </Box>
        </Box>
      </Box>
    </>
  );
}

